import { ABTestPublishedStatus, SelectedStartType } from "../../config/enums";
import { marketingAdministratorRoles } from "../../config/roles";
import { PageBadge, RecordDefinition } from "../recordDefinition.types";
import { LazyCommunicationAudienceSummary } from "../communication/communicationLazy";
import { LazyAbTestStatistics } from "./abtestLazy";
import { abtestPageConfig } from "./abtestPageConfig";
import {
  abtestSaveConfirmation,
  abtestSaveMenu,
  afterABTestSave,
  toABTestPayload,
} from "./abtestRecord";
import {
  abtestEditableRule,
  abtestMinDates,
  abtestOptionFilters,
  abtestValidators,
  abtestVisibilityRules,
  hasWinner,
  isPublishedABTest,
} from "./abtestRules";

const badges: PageBadge[] = [
  {
    id: "status",
    label: (record) =>
      isPublishedABTest(record) ? "Published" : "Unpublished",
    variant: (record) => (isPublishedABTest(record) ? "success" : "info"),
  },
  {
    id: "winner",
    label: (record) =>
      record.g4c_winningcommunication === 0 ? "Winner: A" : "Winner: B",
    variant: () => "success",
    visible: hasWinner,
  },
];

export const abtestRecordDefinition: RecordDefinition = {
  path: "/abtest",
  entityName: "g4c_abtest",
  listRoute: "/abtests",
  backTitle: "Back to A/B tests",
  allowedRoles: marketingAdministratorRoles,
  config: abtestPageConfig,
  // One fixed layout: no extra views and no designer.
  authorable: false,
  identity: {
    titleFields: ["g4c_name"],
    fallbackTitle: "A/B Test",
    newRecordTitle: "New A/B Test",
  },
  badges,
  newRecord: {
    g4c_starttype: SelectedStartType.Immediately,
    g4c_testperiod: 24,
    statuscode: ABTestPublishedStatus.Unpublished,
  },
  toSavePayload: toABTestPayload,
  saveMenu: abtestSaveMenu,
  saveConfirmation: abtestSaveConfirmation,
  afterSave: afterABTestSave,
  editableWhen: abtestEditableRule,
  hideCancelWhenReadOnly: true,
  visibilityRules: abtestVisibilityRules,
  fieldValidators: abtestValidators,
  fieldMinDates: abtestMinDates,
  lookupOptionFilters: abtestOptionFilters,
  fieldComponents: {
    abtestStatistics: LazyAbTestStatistics,
    abtestAudienceSummary: LazyCommunicationAudienceSummary,
  },
};
